/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.26",
    versionName: "0.7.0-nightly.2026.9.26",
    versionChannel: "nightly",
    buildDate: "2026-09-26T00:17:17.423Z",
    commitHash: "5455c72da5472a24cc293a7b13643709e9469587",
};
